

const getters = {
    chartofaccount: (state) => state.chartofaccount,
    id: (state) => state.id,
    loading: state => state.loading
};

export default getters;